module.exports = function (done, value) {
  return { value: value, done: !!done };
};



//////////////////
// WEBPACK FOOTER
// ./~/public-sdk/~/core-js/modules/_iter-step.js
// module id = 196
// module chunks = 0